import {
    inject,
    type InjectionKey,
    provide,
    readonly,
    type Ref,
    ref
} from 'vue'
import type { GiftCardPaymentInfo } from '~/components/Checkout/Sections/PaymentInformation.vue'

export type StoreCreditPaymentInfo = {
    amountUsed: string
}

const CheckoutPaymentDataInjectionKey: InjectionKey<{
    giftCards: Readonly<Ref<GiftCardPaymentInfo[]>>
    updateGiftCards: (newValue: GiftCardPaymentInfo[]) => void
    storeCredit: Readonly<Ref<StoreCreditPaymentInfo>>
    updateStoreCredit: (newValue: StoreCreditPaymentInfo) => void
}> = Symbol('CheckoutPaymentDataInjectionKey')

export function provideCheckoutPaymentData() {
    const giftCards = ref<GiftCardPaymentInfo[]>([])
    const storeCredit = ref<StoreCreditPaymentInfo>({ amountUsed: '0' })

    provide(CheckoutPaymentDataInjectionKey, {
        // @ts-ignore : I don't know why this is failing
        giftCards: readonly(giftCards),
        updateGiftCards: (newValue: GiftCardPaymentInfo[]) => {
            giftCards.value = newValue
        },

        // @ts-ignore : I don't know why this is failing
        storeCredit: readonly(storeCredit),
        updateStoreCredit: (newValue: StoreCreditPaymentInfo) => {
            storeCredit.value = newValue
        }
    })
}

export function useCheckoutPaymentData() {
    const data = inject(CheckoutPaymentDataInjectionKey)
    if (data === undefined) {
        throw new Error('Must provide checkout payment display data')
    }

    return {
        giftCards: data.giftCards,
        storeCredit: data.storeCredit
    }
}

export function useUpdateCheckoutGiftCardData() {
    const data = inject(CheckoutPaymentDataInjectionKey)
    if (data === undefined) {
        throw new Error('Must provide checkout payment display data')
    }

    return data.updateGiftCards
}

export function useUpdateCheckoutStoreCreditData() {
    const data = inject(CheckoutPaymentDataInjectionKey)
    if (data === undefined) {
        throw new Error('Must provide checkout payment display data')
    }

    return data.updateStoreCredit
}
